import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useFormikContext } from "formik"
import {
  getListRegionalAll,
  getListSubRegionalByRole,
  resetUrlResponse,
  uploadAction
} from "../../../../../redux/actions/MasterDataAction.jsx"
import { getUserRegional } from "../../../../service/userManagementAction.js"
import { UploadIcon } from "../../../../../component/atoms/Icons/SVG/upload.jsx"
import { UPLOAD } from "../../../../../constants/InitTypeConstants.js"
import {
  Card,
  CardBody,
  CardHeaderTitle, FieldFeedbackLabel
} from "../../../../../_metronic/_partials/controls/index.js"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import {
  AddressMolecule,
  RadioButtonGroup,
  SelectInput,
  TextInput,
  UploadComponent
} from "../../../../../component/index.jsx"
import { PopUpMapSelector } from "../../../../../component/molecule/PopUpMapSelector/index.jsx"
import { BaseMapSelector } from "../../../../../component/atoms/MapSelector/BaseMapSelector.jsx"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers/index.js"
import { ICON_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { Marker } from "@react-google-maps/api"
import { handleSpace } from "../../../../helpers/TextHelper.js"
import { useTranslation } from "react-i18next"
import { GENDER_REQUEST_ENUM } from "../../../../../constants/StringConstant.js"
import { capitalize } from "@material-ui/core/utils"

export const DataMitraIndividual = ({ mitraTypeEdit, isReadOnly, mitraType, changeType }) => {
  const { MasterData } = useSelector((state) => state)
  const dispatch = useDispatch()
  const [avatar, setAvatar] = useState("")
  const {
    values: formValues,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    errors,
    touched
  } = useFormikContext()
  const [gender, setGender] = useState("")
  const { t } = useTranslation()
  const userLogin = JSON.parse(localStorage.getItem("userLogin"))
  const [regionalList, setRegionalList] = useState([])
  const [subRegionalList, setSubRegionalList] = useState([])
  const [subRegionalId, setSubRegionalId] = useState(null)
  const [enableSubRegional, setEnableSubRegional] = useState(false)
  const [regionalId, setRegionalId] = useState(null)
  const [isHaveRegional, setIsHaveRegional] = useState(false)
  const [isChangeRegional, setIsChangeRegional] = useState(false)
  const [showMapSelector, setShowMapSelector] = useState(false)

  // Sync regional/subRegional from formValues when editing existing mitra
  useEffect(() => {
    if (formValues["regionalId"] && !regionalId) {
      setRegionalId(formValues["regionalId"])
    }
    if (formValues["sub_regional_id"] && !subRegionalId) {
      setSubRegionalId(formValues["sub_regional_id"])
    }
  }, [formValues["regionalId"], formValues["sub_regional_id"]])

  const handleMapSave = ({ lat, lng }) => {
    setFieldValue("latitude", lat)
    setFieldValue("longitude", lng)
    setFieldTouched("latitude", true)
    setFieldTouched("longitude", true)
    setTimeout(() => {
      setFieldError("latitude", undefined)
      setFieldError("longitude", undefined)
    }, 0)
    // Reverse geocode to fill mitraAddress
    if (window.google?.maps?.Geocoder) {
      const geocoder = new window.google.maps.Geocoder()
      geocoder.geocode({ location: { lat, lng }, language: "id" }, (results, status) => {
        if (status === "OK" && results?.[0]) {
          setFieldValue("mitraAddress", results[0].formatted_address)
        }
      })
    }

    setShowMapSelector(false)
  }

  useEffect(() => {
    const userRegional = getUserRegional()
    if (userRegional !== "null") {
      setFieldValue("regionalId", userRegional)
      setRegionalId(userRegional)
      setIsHaveRegional(true)
    }
  }, [regionalList])

  useEffect(() => {
    dispatch(getListRegionalAll())
  }, [dispatch])

  useEffect(() => {
    if ((formValues["regionalId"] && formValues["regionalId"].trim() !== "") ||
      (regionalId && regionalId.trim() !== "")) {
      dispatch(getListSubRegionalByRole(formValues["regionalId"] || regionalId, userLogin?.role));
      setEnableSubRegional(true)
    } else {
      setEnableSubRegional(false)
    }
  }, [formValues["regional_id"], regionalId])

  useEffect(() => {
    if (MasterData.listRegionalAll != undefined) {
      setRegionalList(
        MasterData.listRegionalAll.map((value) => ({
          label: value.name + " (" + value.code + ")",
          value: value.id
        }))
      )
    }
  }, [MasterData.listRegionalAll])

  useEffect(() => {
    if (MasterData.listSubRegionalByRole) {
      setSubRegionalId(formValues["sub_regional_id"] || "")
      setSubRegionalList(
        MasterData.listSubRegionalByRole.map((value) => ({
          label: value.name,
          value: value.id
        }))
      )
    }
  }, [MasterData.listSubRegionalByRole])

  function onChangeRegional(e) {
    setRegionalId(e)
    setIsChangeRegional(true)
    setSubRegionalId("")
  }

  function onChangeAvatar(e) {
    dispatch(uploadAction({ data: e, type: UPLOAD.AVATAR }))
  }

  useEffect(() => {
    if (formValues["mitra_type"]) {
      changeType(formValues)
    }
  }, [formValues])

  useEffect(() => {
    if (MasterData.urlResponseUpload) {
      if (MasterData.uploadType === UPLOAD.AVATAR) {
        setAvatar(MasterData.urlResponseUpload)
      }
    }
    return () => {
      dispatch(resetUrlResponse())
    }
  }, [MasterData.urlResponseUpload])

  const placeholder = <UploadIcon />

  return (
    <>
      <Card className="card-custom card-shadowless">
        <CardBody>
          <RowModule>
            <CardHeaderTitle className={"my-12"}>{"list mitra".toUpperCase()}</CardHeaderTitle>
          </RowModule>
          <RowModule>
            <SelectInput
              required={true}
              name="mitra_type"
              editable={!mitraTypeEdit}
              label={t("label_select_mitra_type")}
              placeholder={t("placeholder_select_one")}
              options={mitraType}
              withoutFeedback={true}
              clearNow={true}
              value={formValues["mitra_type"]}
            />
          </RowModule>
          <RowModule>
            <SelectInput
              name="regionalId"
              required
              onChange={onChangeRegional}
              editable={isHaveRegional ? false : true}
              label={t("label_regional")}
              placeholder={t("label_choose_one")}
              value={regionalId}
              options={regionalList}
            />
          </RowModule>
          <RowModule>
            <SelectInput
              name="sub_regional_id"
              required
              onChange={(e) => setSubRegionalId(e)}
              editable={enableSubRegional}
              label={t("label_sub_regional")}
              placeholder={t("label_choose_one")}
              value={subRegionalId}
              options={subRegionalList}
            />
          </RowModule>
          <RowModule>
            <UploadComponent
              urlParsing={avatar}
              name="mitra_pic_url"
              required
              label={t("label_photo_profile")}
              editable={!isReadOnly}
              onChange={onChangeAvatar}
              placeholder={placeholder}
              maxSize={2048000}
              maxSizeText="2 MB"
            />
          </RowModule>
          <RowModule>
            <TextInput
              editable={!isReadOnly}
              label={t("label_mitra_name")}
              name="name"
              required
              placeholder={t("placeholder_input_mitra_name")}
              onKeyDown={handleSpace}
            />
          </RowModule>
          <RowModule>
            <TextInput
              editable={!isReadOnly}
              label="Email"
              required
              name="email"
              placeholder="Input email"
            />
          </RowModule>
          <RowModule>
            <TextInput
              editable={!isReadOnly}
              type="text"
              label={t("label_phone_number")}
              required
              name="phone"
              placeholder={t("placeholder_input_no_hp")}
            />
          </RowModule>
          <RowModule>
            <TextInput
              editable={!isReadOnly}
              label={t("label_date_of_birth")}
              required
              name="dob"
              type="date"
              placeholder={"mm-dd-yyyy"}
            />
          </RowModule>
          <label>
            {t("label_gender")} <span className={"text-danger"}>*</span>
          </label>
          <RowModule withoutSeparator={true}>
            <RadioButtonGroup
              label={t("label_men")}
              name="gender"
              value={GENDER_REQUEST_ENUM.MALE}
              required
              editable={true}
              withoutFeedback={true}
              checked={gender === GENDER_REQUEST_ENUM.MALE}
              chooseAtBack={true}
              onClick={() => setGender(GENDER_REQUEST_ENUM.MALE)}
            />
            <RadioButtonGroup
              label={t("label_woman")}
              name="gender"
              value={GENDER_REQUEST_ENUM.FEMALE}
              required
              editable={true}
              withoutFeedback={true}
              checked={gender === GENDER_REQUEST_ENUM.FEMALE}
              chooseAtBack={true}
              onClick={() => setGender(GENDER_REQUEST_ENUM.FEMALE)}
            />
          </RowModule>
        </CardBody>
      </Card>
      <RowModule>
        <CardHeaderTitle className={"my-8 ml-8"}>
          {t("label_mitra_domicile_address").toUpperCase()}
        </CardHeaderTitle>
      </RowModule>
      <RowModule>
        <label className={"ml-8"}>
          {capitalize(t("map_pin_location"))} <span className={"text-danger"}>*</span>
        </label>
      </RowModule>
      <RowModule>
        <div
          className={"mx-8 position-relative cursor-pointer"}
          onClick={() => !isReadOnly && setShowMapSelector(true)}>
          {/* Overlay add icon when no location set yet */}
          {!(formValues?.latitude && formValues?.longitude) && (
            <div
              className={
                "position-absolute d-flex justify-content-center align-items-center zindex-3"
              }
              style={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
              <SVG src={toAbsoluteUrl(ICON_CONSTANTS.QUICK_ACTION_ADD)} />
            </div>
          )}
          <div
            className={
              (touched.latitude || touched.longitude) && (errors.latitude || errors.longitude)
                ? "border border-danger rounded-lg"
                : ""
            }>
            <BaseMapSelector
              className={"rounded-lg mb-2"}
              id={"preview-individual-map-selector"}
              latitude={formValues?.latitude}
              longitude={formValues?.longitude}
              isSelector={false}
              editable={false}
              customMarkers={() =>
                formValues?.latitude && formValues?.longitude ? (
                  <Marker
                    position={{
                      lat: parseFloat(formValues.latitude),
                      lng: parseFloat(formValues.longitude)
                    }}
                    icon={toAbsoluteUrl(ICON_CONSTANTS.MARKER_MITRA)}
                    draggable={false}
                  />
                ) : null
              }
              customContainerStyle={{ height: "250px" }}
              options={{ zoomControl: false }}
              zoom={15}
            />
          </div>
          <FieldFeedbackLabel
            error={errors?.latitude || errors?.longitude}
            touched={touched.latitude && touched.longitude}
            label={t("label_base_location_on_map")}
          />
        </div>
      </RowModule>
      <AddressMolecule
        name={"mitra"}
        isReadOnly={isReadOnly}
        required
        regionalId={regionalId}
        byRegional={true}
        isChangeRegional={isChangeRegional}
      />

      {/* Map Section */}
      <PopUpMapSelector
        show={showMapSelector}
        onCancel={() => setShowMapSelector(false)}
        onSave={handleMapSave}
        initialLat={formValues?.latitude}
        initialLng={formValues?.longitude}
        hasLocationAlreadySaved={!!(formValues?.latitude && formValues?.longitude)}
        icon={ICON_CONSTANTS.MARKER_MITRA}
      />
    </>
  )
}
